const getImageSrc = (url: string | undefined) => `/api/imgproxy?url=${url}`;

export { getImageSrc };
